export default __webpack_public_path__ + "static/media/Vitals.669ee3ce.svg";